import { platforms } from "./platforms";
import { genres } from "./genres";
import { games } from "./games";
import { stores } from "./stores";

export const api = {
  platforms,
  genres,
  games,
  stores,
};
